'use client';

import { MyPhotoItem } from 'helpers/hooks/useMyPhotos';
import WidgetPreviewContent from '../widget-preview-content';

type WidgetPreviewProps = {
  photos: MyPhotoItem[];
  activePhotoId: string;
  onSelectPhoto: (photoId: string) => void;
  onGoBack: () => void;
  onRemove?: (photoId: string) => void;
  goBackCtaLabel?: string;
  removeCtaLabel?: string;
  previewErrorMessage?: string;
  previousPhotoLabel?: string;
  nextPhotoLabel?: string;
};

const WidgetPreview = ({
  photos,
  activePhotoId,
  onSelectPhoto,
  onGoBack,
  onRemove,
  goBackCtaLabel,
  removeCtaLabel,
  previewErrorMessage,
  previousPhotoLabel,
  nextPhotoLabel,
}: WidgetPreviewProps) => {
  return (
    <div
      className="relative flex size-full flex-col items-center"
      data-ffid="ctr-my-photos-widget-preview-desktop"
    >
      <div className="w-full min-h-0 flex-1 overflow-y-auto overscroll-contain pb-4">
        <WidgetPreviewContent
          photos={photos}
          activePhotoId={activePhotoId}
          onSelectPhoto={onSelectPhoto}
          previewErrorMessage={previewErrorMessage}
          previousPhotoLabel={previousPhotoLabel}
          nextPhotoLabel={nextPhotoLabel}
          enableSwipe={false}
        />
      </div>

      <div
        className="flex w-full shrink-0 items-center justify-center gap-16 border-t border-[#EBEBEB] bg-white py-24"
        data-ffid="ctr-my-photos-widget-preview-actions"
      >
        <button
          type="button"
          onClick={onGoBack}
          className="rounded-full border border-[#018463] px-24 py-10 text-14 font-medium text-[#018463] transition hover:bg-[#F5F5F5]"
          data-ffid="btn-my-photos-widget-preview-go-back"
        >
          {goBackCtaLabel}
        </button>
        <button
          type="button"
          onClick={() => onRemove?.(activePhotoId)}
          className="rounded-full bg-[#01916D] px-24 py-10 text-14 font-medium text-white transition hover:bg-[#017A5C]"
          data-ffid="btn-my-photos-widget-preview-remove"
        >
          {removeCtaLabel}
        </button>
      </div>
    </div>
  );
};

export default WidgetPreview;